export default function selectMultipleService() {
  return function generate(viewField, engineApi) {
    viewField.metadata = viewField.metadata || {};
    const element = engineApi.field.generateSelect(viewField, engineApi, 'ec-select-multiple');
    if (viewField.metadata.commaList) {
      // en el campo commaList del view, se puede indicar el separador. Pero de momento solo se acepta "," ya que el ec-select-multiple no esta preparado
      if (viewField.metadata.commaList !== ',') {
        throw new Error('De momento, solo funciona con separador "," Por favor, revisa el view y pon: "commaList": ",".');
      }

      element.addAttribute('parse', 'comma-list', true);
      element.addAttribute('comma-list', viewField.metadata.commaList, true);
    }
    return element;
  };
}
